import { render, staticRenderFns } from "./LiveOrders.vue?vue&type=template&id=6a1147e8"
import script from "./LiveOrders.vue?vue&type=script&lang=js"
export * from "./LiveOrders.vue?vue&type=script&lang=js"
import style0 from "./LiveOrders.vue?vue&type=style&index=0&id=6a1147e8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1147e8')) {
      api.createRecord('6a1147e8', component.options)
    } else {
      api.reload('6a1147e8', component.options)
    }
    module.hot.accept("./LiveOrders.vue?vue&type=template&id=6a1147e8", function () {
      api.rerender('6a1147e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BarActions/LiveOrders.vue"
export default component.exports